<template>
  <el-col>
    <el-table :data="dataSource.slice((currentPage-1)*pageSize,currentPage*pageSize)" empty-text="No Data"
              stripe max-height="700" highlight-current-row style="width: 100%">
      <el-table-column label="Year" width="80">
        <template slot-scope="scope" align="center">
          <span>{{ scope.row.year }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="isDisplay" label="Questionnaire Name" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.assessmentNo }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="!isDisplay" label="Assessment Name" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.assessmentNo }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Created by" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.createdBy }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Created at" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.newCreatedDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="Last Updated by" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.modifiedBy }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Last Updated at" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.newModifiedDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="Open Date"  v-if="isDisplay" align="center">
          <template slot-scope="scope">
          <span v-if="scope.row.openDate !== null">{{ scope.row.openDate.substring(0, scope.row.closeDate.lastIndexOf('.')).replace('T', ' ') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Close Date" v-if="isDisplay" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.closeDate !== null">{{scope.row.closeDate.substring(0, scope.row.closeDate.lastIndexOf('.')).replace('T', ' ')}}</span>
        </template>
      </el-table-column>
      <el-table-column label="Status" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.displayedStatus }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Action" width="300" >
        <template slot-scope="scope">
          <el-button icon="el-icon-delete" circle size="mini" v-if="scope.row.year==new Date().getFullYear()" @click="showDeleteWarning(scope.row.id)" :disabled="isDisabled(scope.row.status)"></el-button>
          <el-button icon="el-icon-document" circle size="mini" @click="showPreview(scope.row.id,scope.row.status)"></el-button>
          <el-button size="mini" type="danger" style="margin-left:20px;" v-if="scope.row.year==new Date().getFullYear()" @click="showConfirmDialog(scope.row.id)" :disabled="isDisabled(scope.row.status)">{{buttonConfirm}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="table-nav" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" background
                   :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="dataSource.length">
    </el-pagination>
    <el-dialog title="Confirm" :visible.sync="dialogVisible" width="500px">
      <div style="margin-left: 40px">{{stakeholderConfirmText}}</div><br>
      <div class="block" style="text-align: center">
        <el-date-picker v-model="dateScope" type="daterange" range-separator="To"
                        start-placeholder="Open Date" end-placeholder="Close Date">
        </el-date-picker>
      </div>
      <span slot="footer">
        <el-button @click="dialogVisible=false">{{buttonCancel}}</el-button>
        <el-button type="danger" @click="hideDialog" >{{buttonConfirm}}</el-button>
      </span>
    </el-dialog>
  </el-col>
</template>

<script>
import Constant from '@/common/Constant'
import CookiesHelper from '@/utils/cookiesHelper'
import { callConfirmAssessment, callDeleteAssessment } from '@/services/answerer/assessment.service';
import { confirmQuestionnaire, deleteQuestionnaire } from '@/services/answerer/questionnaire.service';
export default {
  props:
   ['dataSource', 'assessmentType', 'buttonConfirm', 'buttonCancel', 'stakeholderConfirmText'],
  data () {
    return {
      handledAssessmentId: '',
      isDisplay: false,
      dateScope: '',
      dialogVisible: false,
      StakeholderType: Constant.TYPE_STAKEHOLDER,
      VendorType: Constant.TYPE_VENDOR,
      currentPage: 1,
      pageSize: 20,
      totalCount: 0
    }
  },
  methods: {
    checkTheYearRange () {
      let date = this.dateScope[1].getTime() - this.dateScope[0].getTime();
      let day = Math.floor(date / (24 * 3600 * 1000));
      let year = day / 365;
      return year > 2;
    },
    hideDialog () {
      if (this.dateScope === '') {
        this.$alert('Please sign the openDate and closeDate.', {
          confirmButtonText: 'OK'
        });
      } else if (this.checkTheYearRange()) {
        this.$alert('Has exceeded the default time range.', {
          confirmButtonText: 'OK'
        });
        this.dateScope = '';
      } else {
        this.showConfirmWarning(this.handledAssessmentId);
        this.dialogVisible = false;
      }
    },
    showConfirmDialog (id) {
      if (this.assessmentType === this.VendorType) {
        this.showConfirmWarning(id);
      } else {
        this.showDialog(id);
      }
    },
    showDialog (id) {
      this.handledAssessmentId = id;
      this.dialogVisible = true;
    },
    judgeUserType () {
      return false;
    },
    isDisabled (status) {
      return status !== Constant.ASSESSMENT_STATUS_SAVED;
    },
    async showPreview (assessmentId) {
      let {href} = this.$router.resolve({name: 'AssessmentPreview'});
      sessionStorage.setItem(Constant.ASSESSMENT_TYPE, this.assessmentType);
      window.open(href + '?assessmentId=' + assessmentId, '_blank');
    },
    showConfirmWarning (id) {
      this.handledAssessmentId = id;
      this.$confirm(Constant.MESSAGE_CONFIRM_WARNING_TEXT, Constant.MESSAGE_CONFIRM_WARNING_TITLE, {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'Warning'
      }).then(() => {
        this.confirmAssessment();
      }).catch(cancel => {
        console.log(`Cancel Operation`);
      });
    },
    showDeleteWarning (id) {
      this.handledAssessmentId = id;
      this.$confirm(Constant.MESSAGE_DELETE_WARNING_TEXT, Constant.MESSAGE_DELETE_WARNING_TITLE, {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'Warning'
      }).then(() => {
        this.deleteAssessment();
      }).catch(cancel => {
        console.log(`Cancel Operation`);
      });
    },
    deleteAssessment () {
      // todo
      this.$loading({fullscreen: true});
      let userName = CookiesHelper.get('USER_NAME');
      let updateAssessmentStatusDto = {userName: userName, assessmentId: this.handledAssessmentId};
      if (this.assessmentType === Constant.TYPE_VENDOR) {
        callDeleteAssessment(updateAssessmentStatusDto).then(val => {
          this.$emit('initAssessment');
          let updateAssessmentVo = val.data;
          if (updateAssessmentVo.succeed) {
            this.$message.success(Constant.MESSAGE_DELETE_SUCCESSFULLY);
          } else {
            this.$alert(Constant.MESSAGE_DELETE_FAILED, {
              confirmButtonText: 'OK'
            });
          }
        });
      } else {
        deleteQuestionnaire(updateAssessmentStatusDto).then(val => {
          this.$emit('initAssessment');
          let updateAssessmentVo = val.data;
          if (updateAssessmentVo.succeed) {
            this.$message.success(Constant.MESSAGE_DELETE_SUCCESSFULLY);
          } else {
            this.$alert(Constant.MESSAGE_DELETE_FAILED, {
              confirmButtonText: 'OK'
            });
          }
        });
      }
    },
    confirmAssessment: function () {
      this.$loading({fullscreen: true});
      let userName = CookiesHelper.get('USER_NAME');
      let updateAssessmentStatusDto = {userName: userName, assessmentId: this.handledAssessmentId, openDate: this.dateScope[0], closeDate: this.dateScope[1]};
      if (this.assessmentType === Constant.TYPE_VENDOR) {
        callConfirmAssessment(updateAssessmentStatusDto).then(val => {
          this.$emit('initAssessment');
          let updateAssessmentVo = val.data;
          if (updateAssessmentVo.succeed) {
            this.$message.success(Constant.MESSAGE_CONFIRM_SUCCESSFULLY);
          } else {
            this.$alert(Constant.MESSAGE_CONFIRM_FAILED, {
              confirmButtonText: 'OK'
            });
          }
        });
      } else {
        confirmQuestionnaire(updateAssessmentStatusDto).then(val => {
          this.$emit('initAssessment');
          let updateAssessmentVo = val.data;
          if (updateAssessmentVo.succeed) {
            this.$message.success(Constant.MESSAGE_CONFIRM_SUCCESSFULLY);
          } else {
            this.$alert(Constant.MESSAGE_CONFIRM_FAILED, {
              confirmButtonText: 'OK'
            });
          }
        });
      }
    },
    handleSizeChange (val) {
      this.pageSize = val;
    },
    handleCurrentChange (val) {
      this.currentPage = val;
    }
  },
  mounted () {
    if (this.assessmentType === Constant.TYPE_STAKEHOLDER) {
      this.isDisplay = true;
    }
  },
  watch: {
    buttonConfirm: function (newVal, oldVal) {
      this.buttonConfirm = newVal;
    },
    buttonCancel: function (newVal, oldVal) {
      this.buttonCancel = newVal;
    },
    stakeholderConfirmText: function (newVal, oldVal) {
      this.stakeholderConfirmText = newVal;
    }
  }
}
</script>
<style scoped>
  >>>.el-button--danger.is-disabled, .el-button--danger.is-disabled:active, .el-button--danger.is-disabled:hover, .el-button--danger.is-disabled:focus {
    color: #fff;
    background-color: #9ecdfde6;
    border-color: #9ecdfde6;
  }

  >>>.el-button--danger {
    background-color: #5e89ed;
    border-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button--danger:hover {
    background-color: #4b6ebe;
    border-color: #4b6ebe;
    color: #fff;
  }

  >>>.el-button--danger:focus {
    background-color: #4b6ebe;
    border-color: #4b6ebe;
    color: #fff;
  }

  .table-nav{
    position: fixed;
    bottom: 40px;
  }

</style>



// WEBPACK FOOTER //
// src/components/AssessmentTable.vue